/*!
 * Prime Natural Foods Theme — Core JS
 * Original work. No third-party theme code.
 */
(function () {
  'use strict';

  /* ──────────────────────────────────────────────
     UTILITIES
  ────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function off(el, ev, fn) { if (el) el.removeEventListener(ev, fn); }
  function emit(name, detail, el) {
    (el || document).dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function escapeHTML(value) { var el = document.createElement('span'); el.textContent = String(value || ''); return el.innerHTML.replace(/"/g, '&quot;'); }
  function money(cents) {
    if (!window.theme || !window.theme.moneyFormat) {
      return '$' + (cents / 100).toFixed(2);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:window.theme.currency || 'USD'}).format(cents / 100);
  }
  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn.bind(this, arguments), ms); };
  }
  function trap(el) {
    
    function handler(e) {
      if (e.key !== 'Tab') return;
      var focusable = qsa('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(function(node){return !node.closest('[inert]') && node.getClientRects().length > 0;});
      if(!focusable.length) return;
      var first=focusable[0],last=focusable[focusable.length-1];
      if (e.shiftKey) { if (document.activeElement === first) { e.preventDefault(); last.focus(); } }
      else            { if (document.activeElement === last)  { e.preventDefault(); first.focus(); } }
    }
    on(el, 'keydown', handler);
    return function () { off(el, 'keydown', handler); };
  }

  /* ──────────────────────────────────────────────
     LOADING BAR
  ────────────────────────────────────────────── */
  var loadingBar = {
    el: null,
    init: function () {
      this.el = qs('.loading-bar');
    },
    start: function () {
      if (!this.el) return;
      this.el.classList.remove('is-complete');
      this.el.classList.add('is-loading');
    },
    done: function () {
      if (!this.el) return;
      this.el.classList.remove('is-loading');
      this.el.classList.add('is-complete');
      setTimeout(function () {
        if (loadingBar.el) loadingBar.el.classList.remove('is-complete');
      }, 500);
    }
  };

  /* ──────────────────────────────────────────────
     STICKY HEADER
  ────────────────────────────────────────────── */
  function initStickyHeader() {
    var header = qs('.site-header--sticky');
    if (!header) return;
    var last = 0;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      if (y > 80) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
      last = y; ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ──────────────────────────────────────────────
     MOBILE MENU
  ────────────────────────────────────────────── */
  function initMobileMenu() {
    var toggles = qsa('.header [data-mobile-menu-toggle]');
    var menu = qs('[data-mobile-menu]');
    var overlay = qs('[data-mobile-menu-overlay]');
    if (!toggles.length || !menu) return;

    // Move the drawer outside the header stacking context so overlays and
    // fixed positioning remain reliable on iOS/Safari and small Android devices.
    document.body.appendChild(menu);
    if (overlay) document.body.appendChild(overlay);

    var activeToggle = toggles[0];
    var releaseTrap = null;
    var previousBodyOverflow = '';

    function setToggleState(expanded) {
      toggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function closeSubmenu(toggle) {
      if (!toggle) return;
      var id = toggle.getAttribute('aria-controls');
      var submenu = id ? document.getElementById(id) : null;
      if (!submenu || !menu.contains(submenu)) return;

      qsa('[data-mobile-submenu-toggle]', submenu).forEach(function (childToggle) {
        closeSubmenu(childToggle);
      });
      submenu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-expanded');
    }

    function closeSiblingSubmenus(toggle) {
      var item = toggle.closest('li');
      var list = item && item.parentElement;
      if (!list) return;

      Array.from(list.children).forEach(function (siblingItem) {
        if (siblingItem === item) return;
        var siblingToggle = Array.from(siblingItem.children).find(function (child) {
          return child.matches && child.matches('[data-mobile-submenu-toggle]');
        });
        if (siblingToggle && siblingToggle.getAttribute('aria-expanded') === 'true') {
          closeSubmenu(siblingToggle);
        }
      });
    }

    function resetSubmenus() {
      qsa('[data-mobile-submenu-toggle]', menu).forEach(function (toggle) {
        closeSubmenu(toggle);
      });
    }

    function open(trigger) {
      if (menu.classList.contains('is-open')) return;
      activeToggle = trigger || activeToggle || toggles[0];
      previousBodyOverflow = document.body.style.overflow;
      menu.inert = false;
      menu.setAttribute('aria-hidden', 'false');
      menu.classList.add('is-open');
      setToggleState(true);
      document.body.style.overflow = 'hidden';
      document.body.classList.add('mobile-menu-open');
      if (overlay) {
        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
      }
      releaseTrap = trap(menu);
      var first = qs('a[href], button:not([disabled])', menu);
      if (first) first.focus();
    }

    function close(options) {
      options = options || {};
      if (!menu.classList.contains('is-open')) return;
      resetSubmenus();
      menu.inert = true;
      menu.setAttribute('aria-hidden', 'true');
      menu.classList.remove('is-open');
      setToggleState(false);
      document.body.style.overflow = previousBodyOverflow;
      document.body.classList.remove('mobile-menu-open');
      if (overlay) {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
      }
      if (releaseTrap) {
        releaseTrap();
        releaseTrap = null;
      }
      if (options.restoreFocus !== false && activeToggle && activeToggle.getClientRects().length) {
        activeToggle.focus();
      }
    }

    toggles.forEach(function (btn) {
      on(btn, 'click', function () {
        if (menu.classList.contains('is-open')) close();
        else open(btn);
      });
    });

    qsa('[data-mobile-menu-toggle]', menu).forEach(function (btn) {
      on(btn, 'click', function () { close(); });
    });

    on(overlay, 'click', function () { close(); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    // A parent category is one full-width accordion trigger on mobile.
    // Tapping its label, row, or chevron expands children; intentional parent
    // navigation remains available through the explicit “View all” child link.
    qsa('[data-mobile-submenu-toggle]', menu).forEach(function (toggle) {
      on(toggle, 'click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = toggle.getAttribute('aria-controls');
        var submenu = id ? document.getElementById(id) : null;
        if (!submenu || !menu.contains(submenu)) return;

        var opening = submenu.hidden;
        if (!opening) {
          closeSubmenu(toggle);
          return;
        }

        closeSiblingSubmenus(toggle);
        submenu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('is-expanded');

        requestAnimationFrame(function () {
          if (toggle.scrollIntoView) toggle.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      });
    });

    // A normal menu link should navigate immediately. Closing before navigation
    // prevents a stale overlay when pages are restored from browser back/forward cache.
    qsa('.mobile-menu__link[href], .mobile-menu__sublink[href], .mobile-menu__view-all-link[href]', menu).forEach(function (link) {
      on(link, 'click', function () {
        if (link.getAttribute('href') && link.getAttribute('href') !== '#') {
          close({ restoreFocus: false });
        }
      });
    });

    var desktopMedia = window.matchMedia ? window.matchMedia('(min-width: 1008px)') : null;
    if (desktopMedia) {
      var handleDesktop = function (event) {
        if (event.matches) close({ restoreFocus: false });
      };
      if (desktopMedia.addEventListener) desktopMedia.addEventListener('change', handleDesktop);
      else if (desktopMedia.addListener) desktopMedia.addListener(handleDesktop);
    }

    // Safari can restore pages from bfcache with inline overflow left behind.
    on(window, 'pageshow', function () {
      if (!menu.classList.contains('is-open')) {
        document.body.classList.remove('mobile-menu-open');
        if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
      }
    });
  }

  /* ──────────────────────────────────────────────
     HEADER SEARCH (compact dropdown + predictive)
  ────────────────────────────────────────────── */
  function initHeaderSearch() {
    var searchItem = qs('.header__action-item--search');
    if (!searchItem) return;

    var toggle    = qs('[data-action="toggle-search"]', searchItem);
    var wrapper   = qs('.header__search-bar-wrapper', searchItem);
    var form      = qs('.search-bar__form', searchItem);
    var input     = qs('[data-search-input]', searchItem);
    var clearBtn  = qs('[data-search-clear]', searchItem);
    var defaultEl = qs('[data-search-default]', searchItem);
    var loadingEl = qs('[data-search-loading]', searchItem);
    var resultsEl = qs('[data-search-results]', searchItem);
    var closeBtns = qsa('[data-action="close-search"]', searchItem);
    var abortCtrl = null;
    var debounceTimer = null;

    if (!toggle || !wrapper) return;

    function setSearchState(state) {
      if (defaultEl) defaultEl.hidden = state !== 'default';
      if (loadingEl) {
        loadingEl.hidden = state !== 'loading';
        loadingEl.setAttribute('aria-hidden', state !== 'loading' ? 'true' : 'false');
      }
      if (resultsEl) resultsEl.hidden = state !== 'results';
    }

    function resetSearchResults() {
      if (resultsEl) resultsEl.innerHTML = '';
      setSearchState('default');
      if (clearBtn) clearBtn.hidden = true;
    }

    function openSearch() {
      wrapper.classList.add('is-visible');
      wrapper.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      if (input) setTimeout(function () { input.focus(); }, 120);
    }

    function closeSearch() {
      clearTimeout(debounceTimer);
      wrapper.classList.remove('is-visible');
      wrapper.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
      if (input) input.value = '';
      resetSearchResults();
    }

    function getSearchType() {
      var typeInput = form && qs('[name="type"]', form);
      return (typeInput && typeInput.value) || 'product';
    }

    function getProductType() {
      var pt = form && qs('[name="product_type"]', form);
      return pt && pt.value ? pt.value : '';
    }

    function renderSuggestFallback(q) {
      var url = (window.theme.routes.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';

      fetch(url, { signal: abortCtrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!input || input.value.trim() !== q) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            if (resultsEl) {
              resultsEl.innerHTML = '<div class="search-bar__empty-state"><p class="search-bar__empty-title">No results found</p><p class="search-bar__empty-text">Try a different search term.</p></div>';
            }
            setSearchState('results');
            return;
          }
          var html = '<p class="search-bar__result-category">Products</p><div class="search-bar__result-products">';
          html += products.map(function (p) {
            var img = p.featured_image && (p.featured_image.url || p.featured_image);
            var price = p.price ? money(Math.round(Number(p.price) * 100)) : '';
            return '<a href="' + escapeHTML(p.url) + '" class="search-bar__result-item">' +
              '<div class="search-bar__image-container">' +
              (img ? '<img src="' + escapeHTML(img) + '" alt="" width="56" height="56" loading="lazy">' :
                '<span class="search-bar__image-placeholder" aria-hidden="true"></span>') +
              '</div><div class="search-bar__item-info">' +
              '<p class="search-bar__item-title">' + escapeHTML(p.title) + '</p>' +
              (price ? '<span class="search-bar__item-price">' + price + '</span>' : '') +
              '</div></a>';
          }).join('');
          html += '</div><a class="search-bar__view-all" href="/search?q=' + encodeURIComponent(q) +
            '&type=' + encodeURIComponent(getSearchType()) + '">View all results</a>';
          if (resultsEl) resultsEl.innerHTML = html;
          setSearchState('results');
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          setSearchState('default');
        });
    }

    function fetchResults(q) {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      setSearchState('loading');

      var type = getSearchType();
      var productType = getProductType();
      var query = productType ? 'product_type:' + JSON.stringify(productType) + ' AND ' + q : q;
      var url = (window.theme.routes.root || '/') + 'search?q=' + encodeURIComponent(query) + '&type=' + encodeURIComponent(type) + '&view=ajax';
      if (productType) url += '&product_type=' + encodeURIComponent(productType);

      fetch(url, { signal: abortCtrl.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          if (!input || input.value.trim() !== q) return;
          var trimmed = html.trim();
          if (resultsEl) {
            resultsEl.innerHTML = trimmed || '<div class="search-bar__empty-state"><p class="search-bar__empty-title">No results found</p><p class="search-bar__empty-text">Try a different search term.</p></div>';
          }
          setSearchState('results');
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          renderSuggestFallback(q);
        });
    }

    function handleInput() {
      var q = input ? input.value.trim() : '';
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (q.length < 2) {
        if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
        if (resultsEl) resultsEl.innerHTML = '';
        setSearchState('default');
        return;
      }
      fetchResults(q);
    }

    on(toggle, 'click', function (e) {
      e.stopPropagation();
      wrapper.classList.contains('is-visible') ? closeSearch() : openSearch();
    });

    closeBtns.forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        closeSearch();
        toggle.focus();
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && wrapper.classList.contains('is-visible')) {
        closeSearch();
        toggle.focus();
      }
    });

    on(document, 'click', function (e) {
      if (wrapper.classList.contains('is-visible') && !searchItem.contains(e.target)) {
        closeSearch();
      }
    });

    if (input) {
      on(input, 'input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(handleInput, 280);
      });
      on(input, 'keydown', function (e) {
        if (e.key === 'Enter' && form) {
          e.preventDefault();
          form.requestSubmit();
        }
      });
    }

    if (clearBtn && input) {
      on(clearBtn, 'click', function () {
        input.value = '';
        clearBtn.hidden = true;
        if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
        if (resultsEl) resultsEl.innerHTML = '';
        setSearchState('default');
        input.focus();
      });
    }

    if (form && qs('[name="product_type"]', form)) {
      on(qs('[name="product_type"]', form), 'change', function () {
        if (input && input.value.trim().length >= 2) handleInput();
      });
    }
  }

  function initSearch() {
    initHeaderSearch();
  }

  /* ──────────────────────────────────────────────
     MINI CART (DRAWER)
  ────────────────────────────────────────────── */
  var Cart = {
    overlay: null,
    drawer: null,
    count:  null,

    init: function () {
      this.overlay = qs('[data-mini-cart-overlay]');
      this.drawer  = qs('[data-mini-cart]');
      this.count   = qs('[data-cart-count]');

      var openBtns = qsa('[data-mini-cart-open], .header__cart-toggle[data-mini-cart-open], [data-action="toggle-mini-cart"]');
      var self = this;

      openBtns.forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          self.open();
          btn.setAttribute('aria-expanded', 'true');
        });
      });
      on(document, 'click', function (e) {
        var closeBtn = e.target.closest('[data-mini-cart-close]');
        if (closeBtn) { self.close(); return; }
      });
      on(this.overlay, 'click', function () { self.close(); });
      on(document, 'keydown', function (e) { if (e.key === 'Escape') self.close(); });
      on(document, 'cart:open', function () { self.open(); });
      on(document, 'cart:refresh', function () { self.refresh(); });
    },

    open: function () {
      if (!this.drawer) return;
      if(this.drawer.classList.contains('is-open')) { this.refresh(); return; }
      this.refresh();
      this.returnFocus = document.activeElement;
      this.drawer.inert = false;
      this.drawer.setAttribute('aria-hidden', 'false');
      this.releaseTrap = trap(this.drawer);
      this.drawer.classList.add('is-open');
      qs('[data-mini-cart-close]', this.drawer)?.focus();
      if (this.overlay) this.overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.drawer) return;
      if (!this.drawer.classList.contains('is-open')) return;
      this.drawer.inert = true;
      if(this.releaseTrap) this.releaseTrap();
      this.returnFocus?.focus();
      this.drawer.setAttribute('aria-hidden', 'true');
      this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
      qsa('[data-mini-cart-open], .header__cart-toggle').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    },

    refresh: function () {
      var self = this;
      var inner = qs('[data-mini-cart-inner]', this.drawer);
      if (!inner) return;
      inner.innerHTML = '<div class="mini-cart__loading">Loading...</div>';
      return Promise.all([fetchJSON(window.theme.routes.cart + '.js'), fetch(window.theme.routes.cart + '?view=mini-cart').then(function(r){if(!r.ok) throw new Error('Cart unavailable');return r.text();})]).then(function(values){
        self.updateCount(values[0].item_count);
        var doc = new DOMParser().parseFromString(values[1], 'text/html');
        var fresh = doc.querySelector('[data-mini-cart-inner]');
        if (!fresh) throw new Error('Cart markup unavailable');
        inner.innerHTML = fresh.innerHTML;
        self.bindCartActions(inner, values[0]);
      }).catch(function(){ inner.innerHTML = '<p role="alert">Could not refresh cart. <a href="' + window.theme.routes.cart + '">View cart</a></p>'; });
    },

    updateCount: function (n) {
      qsa('[data-cart-count]').forEach(function (el) { el.textContent = n; });
      qsa('.header__cart-count').forEach(function (el) {
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
      });
    },

    bindCartActions: function (el, cart) {
      var self = this;
      qsa('[data-qty-change], [data-qty-btn]', el).forEach(function (btn) {
        on(btn, 'click', function () {
          var key   = btn.dataset.key;
          var delta = btn.dataset.qtyBtn ? (btn.dataset.qtyBtn === 'minus' ? -1 : 1) : Number(btn.dataset.qtyChange);
          var item  = cart.items.find(function (i) { return i.key === key; });
          if (!item) return;
          var newQty = Math.max(0, item.quantity + delta);
          self.updateItem(key, newQty);
        });
      });
      qsa('[data-remove]', el).forEach(function (btn) {
        on(btn, 'click', function () { self.updateItem(btn.dataset.remove, 0); });
      });
    },

    updateItem: function (key, qty) {
      var self = this;
      if(self.updating) return;
      self.updating = true;
      var checkoutButtons = qsa('[name="checkout"]', self.drawer);
      checkoutButtons.forEach(function(button){button.disabled=true;});
      loadingBar.start();
      fetchJSON((window.theme.routes.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (cart) {
        self.updateCount(cart.item_count);
        var inner = qs('[data-mini-cart-inner]', self.drawer);
        return self.refresh().then(function(){ self.updating=false; loadingBar.done(); });
      }).catch(function () { self.updating=false; checkoutButtons.forEach(function(button){button.disabled=false;}); loadingBar.done(); var inner = qs('[data-mini-cart-inner]', self.drawer); if(inner){ var error = document.createElement('p'); error.setAttribute('role','alert'); error.textContent = 'Unable to change quantity. Please check available stock or try again.'; inner.prepend(error); } });
    },

    addItem: function (variantId, qty, opts) {
      var self = this;
      loadingBar.start();
      var body = Object.assign({ id: variantId, quantity: qty || 1 }, opts || {});
      return fetchJSON((window.theme.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function () {
        return fetchJSON((window.theme.routes.root || '/') + 'cart.json');
      }).then(function (cart) {
        self.updateCount(cart.item_count);
        loadingBar.done();
        emit('cart:open');
        return cart;
      }).catch(function (err) {
        loadingBar.done();
        throw err;
      });
    }
  };

  /* ──────────────────────────────────────────────
     ADD TO CART BUTTONS
  ────────────────────────────────────────────── */
  function initAddToCart() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.closest('[data-product-form]')) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId || btn.dataset.addToCart;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      Cart.addItem(variantId, 1).then(function () {
        btn.textContent = 'Added!';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = btn.dataset.originalText || 'Add to Cart';
        }, 1500);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Out of Stock';
      });
    });

    // Save original button text
    qsa('[data-add-to-cart]').forEach(function (btn) {
      btn.dataset.originalText = btn.textContent.trim();
    });
  }

  /* ──────────────────────────────────────────────
     PRODUCT FORM (product page)
  ────────────────────────────────────────────── */
  function initProductForm() {
    var form = qs('[data-product-form]');
    if (!form) return;

    var variantData = JSON.parse(qs('[data-variant-json]', form)?.textContent || '[]');
    var addBtn  = qs('[data-form-submit]', form);
    var priceEl = qs('[data-product-price]');
    var compareEl = qs('[data-product-compare-price]');
    var galleryEl = qs('[data-product-gallery]');

    function getSelectedOptions() {
      return qsa('[data-option-select]', form).map(function (s) { return s.value; });
    }

    function findVariant(opts) {
      return variantData.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateVariant() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      // Update hidden input
      var idInput = qs('[name="id"]', form);
      if (idInput) idInput.value = variant.id;

      // Update price
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Update add button
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Update gallery if variant has image
      if (variant.featured_image && galleryEl) {
        var img = qs('img', galleryEl);
        if (img) {
          img.src = variant.featured_image.src;
          img.srcset = '';
        }
      }
    }

    qsa('[data-option-select]', form).forEach(function (sel) {
      on(sel, 'change', updateVariant);
    });

    // Swatch buttons
    on(form, 'click', function (e) {
      var swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      var group = swatch.closest('[data-option-group]');
      if (group) {
        qsa('[data-swatch]', group).forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');
        var sel = qs('[data-option-select]', group);
        if (sel) { sel.value = swatch.dataset.swatch; updateVariant(); }
      }
    });

    // Form submit
    on(form, 'submit', function (e) {
      e.preventDefault();
      var id = (qs('[name="id"]', form) || {}).value;
      var qty = parseInt((qs('[name="quantity"]', form) || { value: '1' }).value, 10);
      if (!id) return;
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }
      Cart.addItem(id, qty).then(function () {
        if (addBtn) {
          addBtn.textContent = 'Added!';
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }, 1500);
        }
      }).catch(function (err) {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        }
        alert(err.message || 'Could not add to cart.');
      });
    });

    updateVariant();
  }

  /* ──────────────────────────────────────────────
     PRODUCT GALLERY
  ────────────────────────────────────────────── */
  function initProductGallery() {
    var gallery = qs('[data-gallery]');
    if (!gallery) return;

    var main    = qs('[data-gallery-main]', gallery);
    var thumbs  = qsa('[data-gallery-thumb]', gallery);

    thumbs.forEach(function (thumb) {
      on(thumb, 'click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src    = thumb.dataset.src || thumb.src;
        var srcset = thumb.dataset.srcset || '';
        if (main) {
          main.src    = src;
          main.srcset = srcset;
        }
      });
    });

    // Lightbox on click main image
    if (main) {
      on(main, 'click', function () {
        var overlay = document.createElement('div');
        overlay.className = 'modal-overlay is-open';
        overlay.innerHTML = '<div class="gallery-lightbox"><button class="modal__close" aria-label="Close">×</button><img src="' + main.src + '" alt="' + (main.alt || '') + '"></div>';
        document.body.appendChild(overlay);
        on(overlay, 'click', function (e) {
          if (!e.target.closest('.gallery-lightbox img')) overlay.remove();
        });
        on(document, 'keydown', function h(e) { if (e.key === 'Escape') { overlay.remove(); off(document, 'keydown', h); } });
      });
    }
  }

  /* ──────────────────────────────────────────────
     QUANTITY CONTROL
  ────────────────────────────────────────────── */
  function initQuantityControls() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-qty-btn]');
      if (!btn) return;
      var input = qs('[data-qty-input]', btn.closest('[data-qty-wrapper]'));
      if (!input) return;
      var val = Number(input.value) || 0;
      var delta = btn.dataset.qtyBtn === 'minus' ? -1 : 1;
      var min = input.min === '' ? 1 : Number(input.min);
      var max = parseInt(input.max, 10) || 999;
      input.value = Math.min(max, Math.max(min, val + delta));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    });
  }

  /* ──────────────────────────────────────────────
     COLLAPSIBLES / ACCORDION
  ────────────────────────────────────────────── */
  function initCollapsibles() {
    qsa('[data-collapsible-trigger]').forEach(function (trigger) {
      var targetId = trigger.getAttribute('aria-controls') || trigger.dataset.collapsibleTrigger;
      var target   = targetId ? qs('#' + targetId) : trigger.nextElementSibling;
      if (!target) return;
      trigger.setAttribute('aria-expanded', 'false');
      on(trigger, 'click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        target.classList.toggle('is-open', !open);
        if (!open) {
          target.style.maxHeight = target.scrollHeight + 'px';
        } else {
          target.style.maxHeight = '0';
        }
      });
    });
  }

  /* ──────────────────────────────────────────────
     HEADER POPOVERS (account, locale, currency)
  ────────────────────────────────────────────── */
  function initHeaderPopovers() {
    function closeAllPopovers() {
      qsa('#shopify-section-header .popover, .header .popover').forEach(function (p) {
        p.setAttribute('aria-hidden', 'true');
      });
      qsa('[data-action="toggle-popover"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      qsa('.header__account-icon').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    on(document, 'click', function (e) {
      var panelBtn = e.target.closest('[data-action="show-popover-panel"]');
      if (panelBtn) {
        e.preventDefault();
        var panelId = panelBtn.getAttribute('aria-controls');
        var panel = panelId ? qs('#' + panelId) : null;
        var list = panel && panel.closest('.popover__panel-list');
        if (list) {
          qsa('.popover__panel', list).forEach(function (p) { p.classList.remove('is-selected'); });
          if (panel) panel.classList.add('is-selected');
        }
        return;
      }

      var toggle = e.target.closest('[data-action="toggle-popover"]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        var targetId = toggle.getAttribute('aria-controls');
        var target = targetId ? qs('#' + targetId) : null;
        if (!target) return;
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        closeAllPopovers();
        if (!isOpen) {
          target.setAttribute('aria-hidden', 'false');
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (!e.target.closest('.popover') && !e.target.closest('[data-action="toggle-popover"]')) {
        closeAllPopovers();
      }
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') closeAllPopovers();
    });
  }

  /* ──────────────────────────────────────────────
     POPOVER / DROPDOWN
  ────────────────────────────────────────────── */
  function initPopovers() {
    qsa('[data-popover-toggle]').forEach(function (btn) {
      var targetId = btn.dataset.popoverToggle || btn.getAttribute('aria-controls');
      var target   = targetId ? qs('#' + targetId) : null;
      if (!target) return;

      on(btn, 'click', function (e) {
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') === 'true';
        qsa('[data-popover]').forEach(function (p) {
          p.setAttribute('aria-hidden', 'true');
          qs('[data-popover-toggle][aria-controls="' + p.id + '"]') &&
            qs('[data-popover-toggle][aria-controls="' + p.id + '"]').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          target.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    on(document, 'click', function () {
      qsa('[data-popover]').forEach(function (p) {
        p.setAttribute('aria-hidden', 'true');
      });
      qsa('[data-popover-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ──────────────────────────────────────────────
     COOKIE BAR
  ────────────────────────────────────────────── */
  function initCookieBar() {
    var bar = qs('[data-cookie-bar]');
    if (!bar) return;
    if (localStorage.getItem('pnf_cookies_ok')) { bar.remove(); return; }
    bar.removeAttribute('hidden');
    var btn = qs('[data-cookie-accept]', bar);
    on(btn, 'click', function () {
      localStorage.setItem('pnf_cookies_ok', '1');
      bar.remove();
    });
  }

  /* ──────────────────────────────────────────────
     ANNOUNCEMENT NEWSLETTER TOGGLE
  ────────────────────────────────────────────── */
  function initAnnouncementNewsletter() {
    var btn     = qs('[data-ann-newsletter-toggle]');
    var panel   = qs('[data-ann-newsletter]');
    var closBtn = qs('[data-ann-newsletter-close]');
    if (!btn || !panel) return;

    on(btn, 'click', function () {
      var open = panel.getAttribute('aria-hidden') !== 'true';
      panel.setAttribute('aria-hidden', String(open));
      btn.setAttribute('aria-expanded', String(!open));
    });
    on(closBtn, 'click', function () {
      panel.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  /* ──────────────────────────────────────────────
     CURRENCY SELECTOR
  ────────────────────────────────────────────── */
  function initCurrencySelector() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-currency]');
      if (!btn) return;
      var code = btn.dataset.currency;
      if (!code) return;
      fetch('/cart/update.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { preferred_currency: code } })
      }).then(function () { location.reload(); });
    });
  }

  /* ──────────────────────────────────────────────
     SMOOTH SCROLL LINKS
  ────────────────────────────────────────────── */
  function initSmoothScroll() {
    on(document, 'click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var target = qs(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ──────────────────────────────────────────────
     BACK TO TOP
  ────────────────────────────────────────────── */
  function initBackToTop() {
    var btn = qs('[data-back-to-top]');
    if (!btn) return;
    on(window, 'scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });
    on(btn, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ──────────────────────────────────────────────
     COLLECTION FILTERS
  ────────────────────────────────────────────── */
  function initFilters() {
    var form = qs('[data-filter-form]');
    if (!form) return;
    var debouncedSubmit = debounce(function () { form.submit(); }, 400);
    qsa('input[type="checkbox"], input[type="radio"], select', form).forEach(function (el) {
      on(el, 'change', debouncedSubmit);
    });
    on(document, 'click', function (e) {
      var clear = e.target.closest('[data-filter-clear]');
      if (clear) {
        var tag = clear.dataset.filterClear;
        qsa('[name="' + tag + '"]', form).forEach(function (el) {
          el.checked = false; el.selected = false;
        });
        form.submit();
      }
    });
  }

  /* ──────────────────────────────────────────────
     SECTION INIT DISPATCH
  ────────────────────────────────────────────── */
  function initAll() {
    loadingBar.init();
    initStickyHeader();
    initMobileMenu();
    initSearch();
    Cart.init();
    initAddToCart();
    initProductForm();
    initProductGallery();
    initQuantityControls();
    initCollapsibles();
    initPopovers();
    initHeaderPopovers();
    initCookieBar();
    initAnnouncementNewsletter();
    initCurrencySelector();
    initSmoothScroll();
    initBackToTop();
    initFilters();
  }

  if (document.readyState === 'loading') {
    on(document, 'DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Expose Cart globally for inline usage
  window.PNF = { Cart: Cart, money: money };

})();
